module.exports = __webpack_public_path__ + "static/media/ee.830a3880.svg";